import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CommonItemInfoName from "./CommonItemInfoName";

const CommonItemInfo = ({ additionalClass = "", image, name, props, type }) => {
  const { pathname } = useLocation();
  const [isTextVisible, setIsTextVisible] = useState(true);
  const [imageSrc, setImageSrc] = useState(
    image || "https://placehold.co/147x247"
  );

  const getListData = () => {
    const allowedProps = [
      "Win Streak",
      "Event Type",
      "Collection",
      "Rarity",
      "Prize Value",
    ];
    return allowedProps.reduce((data, allowed) => {
      const foundProp = props.find((prop) => prop.title === allowed);
      if (foundProp) data.push(foundProp);
      return data;
    }, []);
  };

  useEffect(() => {
    if (!image) {
      setImageSrc("https://placehold.co/147x247");
      setIsTextVisible(false);
    } else {
      setImageSrc(image);
      setIsTextVisible(true);
    }
  }, [image]);

  return (
    <div className={`cards-list__block-item-info ${additionalClass}`}>
      <img
        src={imageSrc}
        onError={(e) => {
          e.target.src = "https://placehold.co/147x247";
          setIsTextVisible(false);
        }}
        className="cards-list__block-item-pic"
        alt=""
      />
      {(pathname.includes("card-pack-open") ||
        (!pathname.includes("buypacks") && !pathname.includes("card-packs"))) &&
      isTextVisible ? (
        <div className="cards-list__block-item-data">
          <CommonItemInfoName name={name} type={type} />
          <ul>
            {getListData().map((item) => (
              <li key={item.title} data-title={`${item.title}:`} title={item.text}>
                {item.text}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default CommonItemInfo;
